import { savedOrderDetailsTotalStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsTotal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

savedOrderDetailsTotalStyles.cartTotal = {
    labelGridItem: {
        width: 6,
        css: css`
            @media print {
                word-break: normal;
            }
        `,
    },
    valueGridItem: {
        width: 6,
        css: css`
            @media print {
                justify-content: flex-end;
                text-align: right;
                word-break: normal;
            }
        `,
    },
    subtotalLabel: {
        css: css`
        font-size: 14px;
        line-height: ${TYPOGRAPHY.lineHeight.base};
        color: ${getColor("text.main")};
        font-weight: 700;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
            font-size: 12px;
        `,
            null,
            null,
            null,
            null,
        ])}
        @media print {
            font-size: 12px;
            white-space: nowrap;
            word-break: normal;
        }
`,
    },
    subtotalValue: {
        css: css`
        font-size: 14px;
        line-height: ${TYPOGRAPHY.lineHeight.base};
        color: ${getColor("text.main")};
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
            font-size: 12px;
        `,
            null,
            null,
            null,
            null,
        ])}
        /* The grid sets word-break: break-all, which splits the amount mid-number in print. */
        @media print {
            font-size: 12px;
            white-space: nowrap;
            word-break: normal;
            overflow-wrap: normal;
        }
`,
    },
}